import { dbsKeys } from "data/dbsKeys";
import { readCollection, writeCollection } from "data/dbsStorage";

const EMPTY = { provinceIds: [], dealIds: [] };

export const favoritesRepo = {
  get() {
    return readCollection(dbsKeys.favorites, EMPTY);
  },

  toggleProvince(provinceId) {
    const fav = favoritesRepo.get();
    const has = fav.provinceIds.includes(provinceId);
    const provinceIds = has
      ? fav.provinceIds.filter((id) => id !== provinceId)
      : [...fav.provinceIds, provinceId];
    const next = { ...fav, provinceIds };
    writeCollection(dbsKeys.favorites, next);
    return next;
  },

  toggleDeal(dealId) {
    const fav = favoritesRepo.get();
    const has = fav.dealIds.includes(dealId);
    const dealIds = has
      ? fav.dealIds.filter((id) => id !== dealId)
      : [...fav.dealIds, dealId];
    const next = { ...fav, dealIds };
    writeCollection(dbsKeys.favorites, next);
    return next;
  },
};
